<template>
    <Card
        is-match
        is-round
        class="uk-text-center uk-card-hover struct uk-height-1-1 uk-box-shadow-small"
        is-without-body
        v-on:click="onClickFunction">
        <div v-if="listView" class="uk-padding-small">
            <div
                class="uk-grid-small uk-flex-middle uk-child-width-expand uk-flex-center"
                uk-grid>
                <div v-if="$slots.custom">
                    <slot name="custom" />
                </div>

                <div v-if="$slots.beforeLabels">
                    <slot name="beforeLabels" />
                </div>

                <div class="card-spacer" />

                <div v-if="labels && labels.length > 0">
                    <slot name="labels">
                        <div
                            :class="
                                'uk-grid-small uk-flex-center ' +
                                (isLabelsCompact
                                    ? 'uk-child-width-auto'
                                    : 'uk-child-width-1-1')
                            "
                            uk-grid>
                            <div v-for="label in labels" :key="label.name">
                                <Label
                                    :class="label.hidden ? 'uk-invisible' : ''"
                                    :icon="label.icon"
                                    :is-small="isSmall"
                                    :mode="label.mode"
                                    :text="label.name"
                                    :tooltip="label.tooltip" />
                            </div>
                        </div>
                    </slot>
                </div>

                <div v-if="$slots.afterLabels">
                    <slot name="afterLabels" />
                </div>

                <div
                    v-if="actions && actions.length > 0"
                    :class="' ' + (isDummy ? ' uk-invisible' : '')">
                    <slot name="actions">
                        <div
                            class="uk-flex-center uk-grid-small uk-child-width-auto"
                            uk-grid>
                            <div v-for="action in actions" :key="action.name">
                                <ActionButton
                                    :action="action.function"
                                    :icon="action.icon"
                                    :is-disabled="action.disabled"
                                    :is-min="isMin"
                                    :is-small="isSmall"
                                    :loading="action.loading"
                                    :mode="action.mode"
                                    :text="action.name"
                                    :tooltip="action.tooltip" />
                            </div>
                        </div>
                    </slot>
                </div>

                <div v-if="$slots.placeholder" />
            </div>
        </div>
        <div v-else class="uk-text-center card-body-flex">
            <div
                :class="
                    isMin ? '' : isSmall ? 'padding-xsmall' : 'uk-padding-small'
                ">
                <Icon v-if="icon" :icon="icon" :ratio="1.2" />
                <div v-if="name" class="name" v-html="name" />

                <slot name="custom" />

                <slot name="beforeLabels" />

                <slot name="labels">
                    <div
                        :class="
                            'uk-flex-center uk-grid-small ' +
                            (isLabelsCompact
                                ? 'uk-child-width-auto'
                                : 'uk-child-width-1-1')
                        "
                        uk-grid>
                        <div v-for="label in labels" :key="label.name">
                            <LabelV2
                                is-round
                                :class="label.hidden ? 'uk-invisible' : ''"
                                :icon="label.icon"
                                :is-small="isSmall"
                                :mode="label.mode"
                                :text="label.name"
                                :tooltip="label.tooltip" />
                        </div>
                    </div>
                </slot>

                <slot name="afterLabels" />
            </div>

            <div class="card-spacer" />

            <div
                :class="
                    'uk-padding-remove-top ' +
                    (isMin
                        ? ''
                        : isSmall
                        ? 'padding-xsmall'
                        : 'uk-padding-small')
                ">
                <slot name="afterSpacer" />
            </div>

            <div
                v-if="actions && actions.length > 0"
                :class="
                    'uk-card-footer ' +
                    (isSmall ? 'padding-xsmall' : 'uk-padding-small') +
                    (isDummy ? ' uk-invisible' : '')
                ">
                <slot name="actions">
                    <div
                        class="uk-flex-center uk-grid-small uk-child-width-auto"
                        uk-grid>
                        <div v-for="action in actions" :key="action.name">
                            <ActionButton
                                :action="action.function"
                                :icon="action.icon"
                                :is-disabled="action.disabled"
                                :is-min="isMin"
                                :is-small="isSmall"
                                :loading="action.loading"
                                :mode="action.mode"
                                :text="action.name"
                                :tooltip="action.tooltip" />
                        </div>
                    </div>
                </slot>
            </div>
        </div>
    </Card>
</template>

<script>
import Label from '@/components/Label';
import ActionButton from '@/components/generic/ActionButton';
import Card from '@/components/generic/Card.vue';
import Icon from '@/components/generic/Icon.vue';
import LabelV2 from '@/components/generic/LabelV2.vue';

export default {
    name: 'GenericItem',
    components: {LabelV2, Icon, Card, ActionButton, Label},
    props: {
        name: String,
        icon: String,
        labels: Array,
        actions: Array,
        isMin: Boolean,
        isSmall: Boolean,
        isDummy: Boolean,
        onClickFunction: {
            type: Function,
            default() {},
        },
        listView: Boolean,
        isLabelsCompact: Boolean,
    },
};
</script>

<style lang="scss" scoped>
.name {
    font-size: 16px;
    margin-bottom: 15px;
}

.struct {
    color: #444 !important;
    display: flex;
    flex-direction: column;
    height: 100%;
}

.padding-xsmall {
    padding: 6px !important;
}

.custom-width {
    width: 150px;
}

.before-labels-width {
    width: 180px;
}

.labels-width {
    width: 340px;
}

.actions-width {
    width: 100px;
}

.card-body-flex {
    display: flex;
    flex-direction: column;
    flex: 1;
}

.card-spacer {
    flex: 1;
}
</style>
